import { Button, Checkbox, Modal, Select, Spin } from 'antd';
import React, { useState } from 'react';

import type { ModelUserIntegration } from '@app/api/Users';
import { CloseIconsForModalWithDataTestId } from '@app/components';
import { generateSpanWithDataTestId } from '@app/shared/utils';

import type { Dispatch, SetStateAction } from 'react';

const { Option } = Select;

interface IntegrationModalProps {
  options: ModelUserIntegration[];
  isLoading: boolean;
  selectedItems: number[];
  setSelectedItems: Dispatch<SetStateAction<number[]>>;
  isOpen: boolean;
  onSave: (selectedItems: number[]) => void;
  onCancel: () => void;
}

export const AddUserIntegrationsModal: React.FC<IntegrationModalProps> = ({
  options,
  isLoading,
  selectedItems,
  setSelectedItems,
  isOpen,
  onSave,
  onCancel,
}) => {
  const [searchValue, setSearchValue] = useState<string>('');

  const handleSave = () => {
    onSave(selectedItems);
  };

  return (
    <Modal
      title={generateSpanWithDataTestId(
        'Добавление интеграций',
        'add-integrations-popup-title'
      )}
      closeIcon={<CloseIconsForModalWithDataTestId />}
      open={isOpen}
      onOk={handleSave}
      onCancel={onCancel}
      footer={[
        <Button key="back" onClick={onCancel} data-testid="cancel">
          Отмена
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSave}
          data-testid="save"
        >
          Сохранить
        </Button>,
      ]}
      data-testid="add-integrations-popup"
    >
      <Select
        showSearch
        mode="multiple"
        allowClear
        className="add-user-integration-select-container"
        placeholder="Выберите интеграции"
        value={selectedItems}
        searchValue={searchValue}
        onSearch={(value: string) => setSearchValue(value)}
        onChange={(value: number[]) => {
          setSelectedItems(value);
        }}
        optionLabelProp="name"
        optionFilterProp="name"
        notFoundContent={
          isLoading ? (
            <div className="modal-spinner">
              <Spin size="small" />
            </div>
          ) : null
        }
      >
        {options.map((option) => (
          <Option
            key={option.Id}
            value={option.Id}
            label={option.IntegrationName}
            name={`${option.IntegrationName} ${option.AccountLogin}`}
          >
            <Checkbox
              checked={selectedItems.includes(option.Id)}
              data-testid="integration-checkbox-was-added"
            >
              {generateSpanWithDataTestId(
                `${
                  option.IntegrationName
                    ? `Название: ${option.IntegrationName}`
                    : ''
                }${
                  option.AccountLogin ? `, логин: ${option.AccountLogin}` : ''
                }`,
                'integration-name-was-added'
              )}
            </Checkbox>
          </Option>
        ))}
      </Select>
    </Modal>
  );
};
